// Translation: Register > Landing > Form > TOS dialog (Russian)
export default Object.freeze({})
